import { useContext, useEffect, useMemo, useState } from 'react';
import { Button, Slider } from 'antd';
import { AIEditContext } from '../../AIEditContext';
import styles from './index.module.scss';

const ratioList = [
    { value: 'origin', label: '原比例' },
    { value: '1:1', label: '1:1' },
    { value: '2:3', label: '2:3' },
    { value: '3:2', label: '3:2' },
    { value: '3:4', label: '3:4' },
    { value: '4:3', label: '4:3' },
    { value: '9:16', label: '9:16' },
    { value: '16:9', label: '16:9' },
];

const sliderMarks = {
    100: '100%',
    200: '200%',
};

const OutpaintBar = (props) => {
    const { AIEditLoading } = useContext(AIEditContext);
    const [inputValue, setInputValue] = useState(String(props.multiple ?? 125));

    const canApply = useMemo(() => Boolean(props.url), [props.url]);
    const parsedInputValue = Number(inputValue);
    const isInputInvalid = inputValue !== '' && (!Number.isFinite(parsedInputValue) || parsedInputValue < 100 || parsedInputValue > 200);

    useEffect(() => {
        setInputValue(String(props.multiple ?? 125));
    }, [props.multiple]);

    const handleMultipleChange = (value) => {
        if (typeof value !== 'number' || Number.isNaN(value)) return;
        props.onMultipleChange?.(Math.round(value));
    };

    const handleInputChange = (event) => {
        const nextValue = event.target.value.replace(/[^\d]/g, '');
        setInputValue(nextValue);
        if (nextValue === '') return;
        const numericValue = Number(nextValue);
        if (numericValue >= 100 && numericValue <= 200) {
            props.onMultipleChange?.(numericValue);
        }
    };

    const handleInputBlur = () => {
        if (inputValue === '' || isInputInvalid) {
            setInputValue(String(props.multiple ?? 125));
        }
    };

    return (
        <div className={styles.OutpaintBar}>
            <div className={`${styles.OutpaintBarContent} ${!props.url ? styles.disabled : ''}`}>
                <div className={styles.headerRow}>
                    <div className={styles.sectionTitle}>扩图倍数</div>
                    <div className={`${styles.percentInput} ${isInputInvalid ? styles.percentInputInvalid : ''}`}>
                        <input
                            type="text"
                            inputMode="numeric"
                            value={inputValue}
                            onChange={handleInputChange}
                            onBlur={handleInputBlur}
                        />
                        <span>%</span>
                    </div>
                </div>
                <Slider
                    min={100}
                    max={200}
                    step={1}
                    marks={sliderMarks}
                    tooltip={false}
                    value={props.multiple}
                    onChange={handleMultipleChange}
                    className={styles.slider}
                />

                <div className={styles.sectionTitle}>扩图比例</div>
                <div className={styles.ratioGrid}>
                    {ratioList.map((item) => (
                        <button
                            key={item.value}
                            type="button"
                            className={`${styles.ratioBtn} ${props.ratio === item.value ? styles.ratioBtnActive : ''}`}
                            onClick={() => props.onRatioChange?.(item.value)}
                        >
                            {item.value !== 'origin' && <span className={`${styles.ratioIcon} ${styles[`ratioIcon_${item.value.replace(':', '_')}`]}`}></span>}
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>

                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!canApply}
                    className={styles.createBtn}
                    onClick={props.onApply}
                >
                    应用修改
                    <img src={require('@assets/images/arcbean3.png')} alt="" />
                    <span className={styles.beanNum}>5</span>
                </Button>
            </div>
        </div>
    );
};

export default OutpaintBar;
